import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async getUsers(store) {
    const { commit, rootState } = store;
    const { page, per_page } = rootState.misc.pagination;
    return await axios({
      url: `/v1/users/list?page=${page}&per_page=${per_page}&include=roles,permissions,skills`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setUsers', resp.data.data);
        commit('misc/setTotalPages', resp.data.meta.pagination.total_pages, { root: true });
        return Promise.resolve(resp.data.meta.pagination);
      })
      .catch(parseApiError);
  },
  async createUser(store, user) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users`,
      method: 'POST',
      data: { ...user },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(event);
      })
      .catch(parseApiError);
  },
  async updateUser(store, user) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${user.id}`,
      method: 'PUT',
      data: { ...user },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(user);
      })
      .catch(parseApiError);
  },
  async deleteUser(store, userID) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async addRoleToUser(store, { userID, roleID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}/roles`,
      method: 'POST',
      data: { roles: [roleID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteRoleFromUser(store, { userID, roleID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}/roles`,
      method: 'DELETE',
      data: { roles: [roleID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async addPermissionToUser(store, { userID, permissionID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}/permissions`,
      method: 'POST',
      data: { permissions: [permissionID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deletePermissionFromUser(store, { userID, permissionID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}/permissions`,
      method: 'DELETE',
      data: { permissions: [permissionID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async addSkillToUser(store, { userID, skillID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}/skills`,
      method: 'POST',
      data: { skills: [skillID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteSkillFromUser(store, { userID, skillID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/users/${userID}/skills`,
      method: 'DELETE',
      data: { skills: [skillID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getUsers');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;